/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef, use  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts, setCompanies, initQuote, setCompany} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"
import Brand from "../Orderspart/Brand"
import Visuals from "../Orderspart/Visuals"
import Production from "../Orderspart/Production"
import Allaccounts from "../Orderspart/Allaccounts"
import Quotes from "../Orderspart/Quotes"
import Jobs from "../Orderspart/Jobs"
import { toast } from 'react-toastify';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
import Product from "../IndexSections/Product.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardTitle, CardText } from 'reactstrap';
import classnames from 'classnames';
import SelectSearch from '../IndexSections/SelectSearch.js';
import ClientHeader from '../IndexSections/ClientHeader.js';

function Index(props) {
  const main = useRef();
  const [activeTab, setActiveTab] = useState('1');  
  const [contacts, setContacts] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);

  const [contactInfo, setContactInfo] = useState("");
  const [selectedUser, setselectedUser] = useState(null);
  const [selectedContact, setselectedContact] = useState(null);
  // const [companies, setCompanies] = useState(null);
  
  // useEffect(() => {
  //   axios.get(`/contacts/getcontactsforsearch`).then(res => {
  //     if(res.data.status == "success"){     
  //       props.setCompanies(res.data.data)
  //     }
  //   }) 
  // },[]);

  useEffect(() => {
    props.initQuote()
    props.setCompany(null)
  },[]);

  const toggle=(tab)=> {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  const onChangeCompany=(values)=>{
    var value = null;
    if(values && values.length> 0){
      value = values[0]['key'];
      var tmp = value.split(" - ")
      var user = tmp[0]; var contact = tmp[1];
      setselectedUser(user)
      setselectedContact(contact)
      // axios.get(`/contacts/getcontact?id=${contact}`).then(res => {
      //   if(res.data.status == "success"){     
      //     setContactInfo(res.data.data)
      //   }
      // }) 
    }   
    else{
      setselectedUser(null)
      setselectedContact(null)  
      setContactInfo(null)
    } 
    setSelectedCompany(values)
  }

  const createQuote = ()=>{
    if(selectedUser){
      var bodyFormData = new FormData();
      axios.post(`/quotes/add/?userid=${selectedUser}`, bodyFormData).then(res => {
        const result = res.data;
        if(result.status == "success"){  
          props.history.push(`/admin/requests/edit/${result.data.id}`)
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {
        toast.error('Something was wrong. Try again');
      })

    }
    else{
      alert("Please select company first.");
    }
  }

  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row className="mt-5 mb-5">
            <Col md="12">
              <FormGroup className="">        
                <Button className="btn-icon btn-2 float-right rounded-0 d-flex align-items-center" color="primary" type="button"  onClick={createQuote}>
                  <span className="btn-inner--icon mr-2 yello-icon">
                    <i className="fa fa-plus" />
                  </span>
                  NEW QUOTE REQUEST
                </Button>    
                <Button className="btn-icon btn-2 float-right mr-2 rounded-0 d-flex align-items-center" color="primary" type="button"  onClick={()=>{setselectedUser(null); setselectedContact(null); onChangeCompany([]); toggle('1');}}>
                  <span className="btn-inner--icon mr-2 yello-icon">
                    <i className="fa fa-plus" />
                  </span>
                  NEW CLIENT
                </Button> 
              </FormGroup>
            </Col>
          </Row>
          {/* <Row>
            {props.quote.companies && props.quote.companies.length > 0 &&
            <Col sm="3">
              <SelectSearch className="select-company" options={props.quote.companies} placeholder="Search Company" onChange={values => {onChangeCompany(values)}} values={selectedCompany} searchBy="label" labelField="label" valueField="key" />
              {
                  (contactInfo) &&
                      <div className="position-relative" style={{fontSize:'13.5px', padding:'5px'}}>
                        <div className=" mb-0">
                          {contactInfo['company']?contactInfo['company']:""}<br/>
                          {contactInfo['mobile']?contactInfo['mobile']:""}<br/><br/>
                          {contactInfo['address']?contactInfo['address']:""}<br/>
                          {(contactInfo['suburb']?(contactInfo['suburb']+", "):"")+(contactInfo['state']?(contactInfo['state']+", "):"")+(contactInfo['postcode']?contactInfo['postcode']:"")}<br/>
                        </div>
                      </div>
                }
            </Col>
            }
          </Row> */}
          <ClientHeader onChangeCompany={values => {onChangeCompany(values)}} selectedCompany={selectedCompany}/>
          <Row className="mt-3 orders-tabs">
            <Col  md="12">
              <div>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => { toggle('1'); }}
                    >
                      Clients
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '2' })}
                      onClick={() => { toggle('2'); }}
                    >
                      Brand
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '3' })}
                      onClick={() => { toggle('3'); }}
                    >
                      Quotes
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '4' })}
                      onClick={() => { toggle('4'); }}
                    >
                      Jobs
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '5' })}
                      onClick={() => { toggle('5'); }}
                    >
                      Visuals
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '6' })}
                      onClick={() => { toggle('6'); }}
                    >
                      Production
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '7' })}
                      onClick={() => { toggle('7'); }}
                    >
                      Info
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1" className="">
                    <Row>
                      <Col sm="12">
                          <Allaccounts history={props.history} selectedUser={selectedUser} selectedContact={selectedContact}/>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2" className="">
                    <Row>
                      <Col sm="12">
                        <Card body>
                          <Brand selectedUser={selectedUser} selectedContact={selectedContact}/>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="3" className="">
                    <Row>
                      <Col sm="12">
                        <Card body>
                          <Quotes  history={props.history} selectedUser={selectedUser} selectedContact={selectedContact}/>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="4" className="">
                    <Row>
                      <Col sm="12">
                        <Card body>
                          <Jobs history={props.history} selectedUser={selectedUser} selectedContact={selectedContact}/>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="5" className="">
                    <Row>
                      <Col sm="12">
                        <Card body>
                          <Visuals selectedUser={selectedUser} selectedContact={selectedContact}/>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="6" className="">
                    <Row>
                      <Col sm="12">
                          <Production selectedUser={selectedUser} selectedContact={selectedContact} />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="7" className="">
                    <Row>
                      <Col sm="12">
                        <Card body>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
        <LoadingOverlay
          active={props.quote.loadingFlag||props.quote.quoteLoading}
          styles={{
              overlay: (base) => ({
              ...base,
              fontSize:'18px',
              color: 'rgb(5, 37, 51)',
              background: 'rgb(60 60 60 / 48%)',
              position:'fixed',
              zIndex:1000000000
              })
          }}
          spinner = {<ScaleLoader color={'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
          // spinner
          // text='Loading ...'
          >
        </LoadingOverlay> 
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    setCompanies: companies=>dispatch(setCompanies(companies)),
    initQuote:() => dispatch(initQuote()),
    setCompany:(data)=>dispatch(setCompany(data)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
